import { Dropdown } from "primereact/dropdown";
import React, { useState } from "react";
import patchItem from "Services/patchItem";

const BadgeToDriver = ({ row, drivers }) => {

  const options = drivers.map(driver => ({
    value: driver.code,
   // label: driver.completename
    label: driver.label
  }));

  const [selectedDriver, setSelectedDriver] = useState(() => {
    const matchingDriver = drivers.find(
      //driver => driver.completename === row.driver_name
      driver => driver.label === row.driver_name
    );
    return matchingDriver?.code || null;
  });

  const handleChange = async (event) => {
    const newDriver = event.value;
    const badgeCode = row.code;
    
    try {
      if (newDriver) {
        const url = `/front/user/${newDriver}/badge/${badgeCode}`;
        await patchItem(url);
      } else {
        const currentDriver = drivers.find(
          //driver => driver.completename === row.driver_name
          driver => driver.label === row.driver_name
        );
        if (currentDriver) {
          const unavailableBadge = `/front/user/${currentDriver.code}/badge`;
          await patchItem(unavailableBadge);
        }
      }
      setSelectedDriver(newDriver);
    } catch (error) {
      console.error('Error updating badge assignment:', error);
    }
  };

  return (
    <Dropdown
      value={selectedDriver}
      onChange={handleChange}
      options={options}
      optionLabel="label"
      showClear
      filter
      placeholder={row.driver_name || "Select Driver"}
      className="w-full"
      appendTo={document.body}
    />
  );
};

export default BadgeToDriver;
